import {Component, effect, inject, input, signal, untracked} from '@angular/core';
import {AnimalsStore} from 'src/app/domain/assets/animals/animals.store';
import {
  AnimalDetailsContainerComponent
} from "src/app/presentation/main-view/information-center/animals/animal-details/animal-details-container/animal-details-container.component";
import {Animal} from 'src/app/infrastructure/moovement-api/models/asset';
import {MapStore} from 'src/app/domain/map/map.store';
import {LocationService} from 'src/app/domain/samples/location/location.service';
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {LocationStore} from 'src/app/domain/samples/location/location.store';
import {MapStateService} from 'src/app/presentation/main-view/map-container/map-container-component';
import {NfcLocationStore} from 'src/app/domain/samples/nfc-location/nfc-location.store';
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {DeviceType} from 'src/app/domain/devices/device';
import {NfcLocationService} from 'src/app/domain/samples/nfc-location/nfc-location.service';
import {
  HistoricalLocationFilter,
  HistoricalLocationStore
} from 'src/app/domain/samples/historical-location/historical-location.store';

@Component({
  selector: 'app-historical-animal-locations',
  standalone: true,
  imports: [
    AnimalDetailsContainerComponent
],
  templateUrl: './historical-animal-locations.component.html',
  styleUrl: './historical-animal-locations.component.css'
})
export class HistoricalAnimalLocationsComponent {

  id = input.required<string>();

  animal = signal<Animal | undefined>(undefined);
  filterOptions = [HistoricalLocationFilter.TEN_LATEST, HistoricalLocationFilter.ALL]

  historicalLocationStore = inject(HistoricalLocationStore);
  locationStore = inject(LocationStore);
  nfcLocationStore = inject(NfcLocationStore);

  private deviceType = signal<DeviceType | undefined>(undefined);

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private animalStore = inject(AnimalsStore);
  private deviceStore = inject(DeviceStore);
  private farmStore = inject(FarmStore);
  private mapStore = inject(MapStore);

  constructor(
    private locationService: LocationService,
    private mapStateService: MapStateService,
    private nfcLocationService: NfcLocationService
  ) {
    effect(() => {
      const initializedMap = this.mapStore.initializedMap();
      if (!initializedMap) return;

      this.mapStateService.removeLocator();
      this.mapStore.hideAnimalLocationLayer();
      this.mapStore.showHistoricAnimalLocationLayer();
    });

    effect(() => {
      const id = this.id();
      if (!id) return;

      const animal = this.animalStore.entityMap()[id];
      this.animal.set(animal);
    });

    effect(() => {
      if (this.animalStore.loading() || this.deviceStore.loading()) return;

      const id = this.id();
      const deviceId = this.animalStore.animalIdToDeviceId().get(id);
      if (!deviceId) return;

      const deviceType = this.deviceStore.deviceIdToType().get(deviceId);

      this.deviceType.set(deviceType);
    });

    effect(() => {
      const deviceType = this.deviceType();
      if (!deviceType) return;

      this.historicalLocationStore.setDeviceType(deviceType);
    });

    effect(() => {
      if (this.aggregatedAssetStateStore.loading()
        || this.farmStore.loading()
        || this.deviceStore.loading()
      ) return;

      const id = this.id();
      const farm = this.farmStore.farm();
      if (!farm) return;

      const deviceType = this.deviceType();
      if (!deviceType) return;

      const state = this.aggregatedAssetStateStore.entityMap()[id];

      if (deviceType === DeviceType.NFC_TAG) {
        untracked(() => this.nfcLocationService.loadLocations(id, state));
      } else {
        untracked(() => this.locationService.loadLocations(id, farm.skipAnomalousLocations, state));
      }
    });
  }

  back() {
    this.mapStore.resetLayers();
  }

  setFilter(filter: HistoricalLocationFilter) {
    this.historicalLocationStore.setFilter(filter);
  }

  protected close() {
    this.mapStore.resetLayers();
  }
}
